
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function ColoredDot(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("w-3.5"), delay(() => append(singleton("h-3.5"), delay(() => append(singleton("rounded-full"), delay(() => {
        const matchValue = props.Color;
        return (matchValue === "red") ? singleton("bg-[#F99D9D]") : ((matchValue === "orange") ? singleton("bg-[#f9d49d]") : ((matchValue === "grey") ? singleton("bg-[#F2F2F2]") : singleton("bg-[#D4FAAF]")));
    })))))))))))))))], (elems = [reactElement("div", {
        className: join(" ", toList(delay(() => append(singleton("w-1.5"), delay(() => append(singleton("h-1.5"), delay(() => append(singleton("rounded-full"), delay(() => {
            const matchValue_1 = props.Color;
            return (matchValue_1 === "red") ? singleton("bg-red") : ((matchValue_1 === "orange") ? singleton("bg-[#eba44d]") : ((matchValue_1 === "grey") ? singleton("bg-[#8A8A8A]") : singleton("bg-[#50BF00]")));
        }))))))))),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

